<!-- 公共的logo，crawl选择-->
<template>
  <div class="PublicFileSelect">
    <div class="SelectVideo" :title="SelectValue.fileName">
      <el-select
        v-model="pitchOnFile"
        :disabled="disabled"
        :popper-append-to-body="AppendBody"
        popper-class="file-search-select"
        :placeholder="$t('lang.select')"
        @change="fileSelectChange"
        >
        <el-option
          v-for="item in FileSelectList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
          <span class="videoLeft" style="float: left;width: 100%;overflow: hidden;text-overflow: ellipsis;" :title="item.name">{{ item.name }}</span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
import { componentsAnalyze } from '../../assets/js/googleAnalyze/playout.js'
export default {
  props: {
    //   选择的类型  1是logo选择类型  2是crawl选择类型
    SelectType: {
      type: Number,
      default: 1
    },
    //   选择的参数
    SelectValue: {
      type: Object,
      default: () => ({
        fileId: '',
        fileName: ''
      })
    },
    // 选项列表
    FileSelectList: {
      type: Array,
      default: () => []
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否将弹出框插入至 body 元素,在弹出框的定位出现问题时，可将该属性设置为 false
    AppendBody: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      //   选中的文件id
      pitchOnFile: '',
      // 加载
      FirstLoading: false,
      // 拥有者Id
      OwnerUserid: ''
    }
  },
  created () {
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    this.OwnerUserid = Outil.getProgramReceiver('ownerUserId')
  },
  mounted () {
    this.FileEcho()
  },
  watch: {
    // 监听外部传的值是否变化
    SelectValue (item) {
      this.FileEcho()
    }
  },
  methods: {
    // 第一次获取数据
    FirstGetData () {
      this.FirstLoading = true
      if (this.SelectType == 1) {
        this.showThumbList()
      } else if (this.SelectType == 2) {
        this.getCrawlList()
      }
    },
    // 获取图标
    showThumbList () {
      this.axios.post('/file/query-user-files', {
        isDirectory: false,
        region: this.RegionInfo.region,
        service: this.RegionInfo.ServerName,
        bucketId: this.RegionInfo.bucketId,
        type: 1,
        directoryName: '/Images/Playout',
        userId: this.OwnerUserid,
        pageSize: 1000
      }, {
        requestBase: 'GATEWAY'
      }).then((res) => {
        const { errorCode } = res.data
        if (errorCode === '0x0') {
          this.FileSelectList = res.data.result.records
          this.FirstLoading = false
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取crawl列表
    getCrawlList () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/crawl/getCrawlMessage', {
        entityType: 0,
        entityId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const FileSelectList = []
            const widgets = JSON.parse(res.data.result).scene.preview.widgets
            if (widgets && widgets.length > 0) {
              widgets.forEach((item) => {
                FileSelectList.push({
                  id: item.id,
                  name: item.properties.widgetName
                })
              })
              this.FileSelectList = FileSelectList
            } else {
              this.FileSelectList = []
            }
            this.FirstLoading = false
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 文件回显
    FileEcho (list) {
      if (this.SelectValue.fileName) {
        let inquire = false
        this.FileSelectList.forEach((item) => {
          if (item.id == this.SelectValue.fileId) inquire = true
        })
        this.pitchOnFile = inquire ? this.SelectValue.fileId : this.SelectValue.fileName
      } else {
        this.pitchOnFile = this.SelectValue.fileId
      }
    },
    // 文件选中变化
    fileSelectChange () {
      componentsAnalyze('publicFileSelectSelectedChange', '/ponent')
      const FileMessage = this.FileSelectList.filter(
        (item) => item.id === this.pitchOnFile
      )
      this.$emit('fileSelectChange', {
        fileId: FileMessage[0].id,
        name: FileMessage[0].name
      })
    }
  }
}
</script>
<style scoped lang="less">
.PublicFileSelect{
  .SelectVideo{
    ::v-deep .el-select-dropdown{
      .el-scrollbar__wrap{
        .el-scrollbar__view{
          width: 100%;
        }
      }
    }
  }
}
</style>
